/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CancelBillingSubscriptionResponse,
  CreateBillingCouponRedemptionResponse,
  CreateBillingWalletData,
  CreateBillingWalletResponse,
  CreateCouponRedemptionData,
  CreatePaymentMethodData,
  CreatePaymentMethodResponse,
  CreatePaymentMethodSetupSessionData,
  CreatePaymentMethodSetupSessionResponse,
  CreateSetupIntentResponse,
  CreateSubscriptionQuoteData,
  CreateSubscriptionQuoteResponse,
  ListBillingPackagesResponse,
  ListBillingProductPricesResponse,
  ListBillingQuotaDefinitionsResponse,
  ListBillingWalletTypesResponse,
  ListBillingWalletsResponse,
  ListCouponRedemptionsResponse,
  ListInvoicesResponse,
  ListNextBillingEventsResponse,
  ListPaymentMethodsResponse,
  ListReferralsResponse,
  RefreshInvoiceUrlResponse,
  ResumeBillingSubscriptionResponse,
  ShowBillingDetailsResponse,
  ShowBillingOverviewResponse,
  ShowInvoiceResponse,
  ShowLatestSubscriptionResponse,
  ShowReferrerDetailsResponse,
  TopUpBillingWalletData,
  TopUpBillingWalletResponse,
  UpdateBillingDetailsData,
  UpdateBillingDetailsResponse,
  UpdateBillingSubscriptionData,
  UpdateBillingSubscriptionResponse,
  UpdateBillingWalletData,
  UpdateBillingWalletResponse,
  UpdatePaymentMethodData,
  UpdatePaymentMethodResponse,
} from '../models/index';
import {
    CancelBillingSubscriptionResponseFromJSON,
    CancelBillingSubscriptionResponseToJSON,
    CreateBillingCouponRedemptionResponseFromJSON,
    CreateBillingCouponRedemptionResponseToJSON,
    CreateBillingWalletDataFromJSON,
    CreateBillingWalletDataToJSON,
    CreateBillingWalletResponseFromJSON,
    CreateBillingWalletResponseToJSON,
    CreateCouponRedemptionDataFromJSON,
    CreateCouponRedemptionDataToJSON,
    CreatePaymentMethodDataFromJSON,
    CreatePaymentMethodDataToJSON,
    CreatePaymentMethodResponseFromJSON,
    CreatePaymentMethodResponseToJSON,
    CreatePaymentMethodSetupSessionDataFromJSON,
    CreatePaymentMethodSetupSessionDataToJSON,
    CreatePaymentMethodSetupSessionResponseFromJSON,
    CreatePaymentMethodSetupSessionResponseToJSON,
    CreateSetupIntentResponseFromJSON,
    CreateSetupIntentResponseToJSON,
    CreateSubscriptionQuoteDataFromJSON,
    CreateSubscriptionQuoteDataToJSON,
    CreateSubscriptionQuoteResponseFromJSON,
    CreateSubscriptionQuoteResponseToJSON,
    ListBillingPackagesResponseFromJSON,
    ListBillingPackagesResponseToJSON,
    ListBillingProductPricesResponseFromJSON,
    ListBillingProductPricesResponseToJSON,
    ListBillingQuotaDefinitionsResponseFromJSON,
    ListBillingQuotaDefinitionsResponseToJSON,
    ListBillingWalletTypesResponseFromJSON,
    ListBillingWalletTypesResponseToJSON,
    ListBillingWalletsResponseFromJSON,
    ListBillingWalletsResponseToJSON,
    ListCouponRedemptionsResponseFromJSON,
    ListCouponRedemptionsResponseToJSON,
    ListInvoicesResponseFromJSON,
    ListInvoicesResponseToJSON,
    ListNextBillingEventsResponseFromJSON,
    ListNextBillingEventsResponseToJSON,
    ListPaymentMethodsResponseFromJSON,
    ListPaymentMethodsResponseToJSON,
    ListReferralsResponseFromJSON,
    ListReferralsResponseToJSON,
    RefreshInvoiceUrlResponseFromJSON,
    RefreshInvoiceUrlResponseToJSON,
    ResumeBillingSubscriptionResponseFromJSON,
    ResumeBillingSubscriptionResponseToJSON,
    ShowBillingDetailsResponseFromJSON,
    ShowBillingDetailsResponseToJSON,
    ShowBillingOverviewResponseFromJSON,
    ShowBillingOverviewResponseToJSON,
    ShowInvoiceResponseFromJSON,
    ShowInvoiceResponseToJSON,
    ShowLatestSubscriptionResponseFromJSON,
    ShowLatestSubscriptionResponseToJSON,
    ShowReferrerDetailsResponseFromJSON,
    ShowReferrerDetailsResponseToJSON,
    TopUpBillingWalletDataFromJSON,
    TopUpBillingWalletDataToJSON,
    TopUpBillingWalletResponseFromJSON,
    TopUpBillingWalletResponseToJSON,
    UpdateBillingDetailsDataFromJSON,
    UpdateBillingDetailsDataToJSON,
    UpdateBillingDetailsResponseFromJSON,
    UpdateBillingDetailsResponseToJSON,
    UpdateBillingSubscriptionDataFromJSON,
    UpdateBillingSubscriptionDataToJSON,
    UpdateBillingSubscriptionResponseFromJSON,
    UpdateBillingSubscriptionResponseToJSON,
    UpdateBillingWalletDataFromJSON,
    UpdateBillingWalletDataToJSON,
    UpdateBillingWalletResponseFromJSON,
    UpdateBillingWalletResponseToJSON,
    UpdatePaymentMethodDataFromJSON,
    UpdatePaymentMethodDataToJSON,
    UpdatePaymentMethodResponseFromJSON,
    UpdatePaymentMethodResponseToJSON,
} from '../models/index';

export interface CancelBillingSubscriptionRequest {
    id: number;
}

export interface CreateBillingCouponRedemptionRequest {
    createCouponRedemptionData?: CreateCouponRedemptionData;
}

export interface CreateBillingWalletRequest {
    createBillingWalletData?: CreateBillingWalletData;
}

export interface CreatePaymentMethodRequest {
    createPaymentMethodData?: CreatePaymentMethodData;
}

export interface CreatePaymentMethodSetupSessionRequest {
    createPaymentMethodSetupSessionData?: CreatePaymentMethodSetupSessionData;
}

export interface CreateSetupIntentRequest {
    _with?: Array<string>;
}

export interface CreateSubscriptionQuoteRequest {
    createSubscriptionQuoteData?: CreateSubscriptionQuoteData;
}

export interface DeletePaymentMethodRequest {
    id: number;
}

export interface ListBillingPackagesRequest {
    _with?: Array<string>;
    limit?: number;
    orderBy?: Array<string>;
    page?: number;
    perPage?: number;
    where?: { [key: string]: object; };
}

export interface ListBillingProductPricesRequest {
    page?: number;
    perPage?: number;
    where?: { [key: string]: object; };
}

export interface ListBillingWalletTypesRequest {
    perPage?: number;
    page?: number;
}

export interface ListBillingWalletsRequest {
    perPage?: number;
    page?: number;
}

export interface ListInvoicesRequest {
    limit?: number;
    orderBy?: Array<string>;
    page?: number;
    perPage?: number;
    where?: { [key: string]: object; };
    _with?: Array<string>;
}

export interface ListReferralsRequest {
    _with?: Array<string>;
}

export interface RefreshInvoiceUrlRequest {
    id: number;
}

export interface ResumeBillingSubscriptionRequest {
    id: number;
}

export interface ShowBillingDetailsRequest {
    _with?: Array<string>;
}

export interface ShowInvoiceRequest {
    id: number;
    _with?: Array<string>;
}

export interface ShowLatestSubscriptionRequest {
    _with?: Array<string>;
}

export interface ShowReferrerDetailsRequest {
    companyRef: string;
}

export interface TopUpBillingWalletRequest {
    id: number;
    topUpBillingWalletData?: TopUpBillingWalletData;
}

export interface UpdateBillingDetailsRequest {
    _with?: Array<string>;
    updateBillingDetailsData?: UpdateBillingDetailsData;
}

export interface UpdateBillingSubscriptionRequest {
    updateBillingSubscriptionData?: UpdateBillingSubscriptionData;
}

export interface UpdateBillingWalletRequest {
    id: number;
    updateBillingWalletData?: UpdateBillingWalletData;
}

export interface UpdatePaymentMethodRequest {
    id: number;
    updatePaymentMethodData?: UpdatePaymentMethodData;
}

/**
 * 
 */
export class BillingApi extends runtime.BaseAPI {

    /**
     * Mark the subscription as cancelling at the end of the current subscription period.
     * Cancel Billing Subscription
     */
    async cancelBillingSubscriptionRaw(requestParameters: CancelBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelBillingSubscriptionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling cancelBillingSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-subscription.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/subscriptions/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelBillingSubscriptionResponseFromJSON(jsonValue));
    }

    /**
     * Mark the subscription as cancelling at the end of the current subscription period.
     * Cancel Billing Subscription
     */
    async cancelBillingSubscription(requestParameters: CancelBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelBillingSubscriptionResponse> {
        const response = await this.cancelBillingSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Coupon Redemption
     */
    async createBillingCouponRedemptionRaw(requestParameters: CreateBillingCouponRedemptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBillingCouponRedemptionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-coupon-redemption.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/coupons/redemptions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCouponRedemptionDataToJSON(requestParameters['createCouponRedemptionData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateBillingCouponRedemptionResponseFromJSON(jsonValue));
    }

    /**
     * Create Coupon Redemption
     */
    async createBillingCouponRedemption(requestParameters: CreateBillingCouponRedemptionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBillingCouponRedemptionResponse> {
        const response = await this.createBillingCouponRedemptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Billing Wallet
     */
    async createBillingWalletRaw(requestParameters: CreateBillingWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateBillingWalletResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-wallet.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/wallets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBillingWalletDataToJSON(requestParameters['createBillingWalletData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateBillingWalletResponseFromJSON(jsonValue));
    }

    /**
     * Create Billing Wallet
     */
    async createBillingWallet(requestParameters: CreateBillingWalletRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateBillingWalletResponse> {
        const response = await this.createBillingWalletRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Payment Method
     */
    async createPaymentMethodRaw(requestParameters: CreatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePaymentMethodResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-payment-method.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/payment-methods`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePaymentMethodDataToJSON(requestParameters['createPaymentMethodData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePaymentMethodResponseFromJSON(jsonValue));
    }

    /**
     * Create Payment Method
     */
    async createPaymentMethod(requestParameters: CreatePaymentMethodRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePaymentMethodResponse> {
        const response = await this.createPaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Create Payment Method Setup Session
     */
    async createPaymentMethodSetupSessionRaw(requestParameters: CreatePaymentMethodSetupSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePaymentMethodSetupSessionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-payment-method.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/payment-methods/setup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePaymentMethodSetupSessionDataToJSON(requestParameters['createPaymentMethodSetupSessionData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePaymentMethodSetupSessionResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Create Payment Method Setup Session
     */
    async createPaymentMethodSetupSession(requestParameters: CreatePaymentMethodSetupSessionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePaymentMethodSetupSessionResponse> {
        const response = await this.createPaymentMethodSetupSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a stripe setup intent.
     * Create Setup Intent
     */
    async createSetupIntentRaw(requestParameters: CreateSetupIntentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSetupIntentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-payment-intent.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/intent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSetupIntentResponseFromJSON(jsonValue));
    }

    /**
     * Create a stripe setup intent.
     * Create Setup Intent
     */
    async createSetupIntent(requestParameters: CreateSetupIntentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSetupIntentResponse> {
        const response = await this.createSetupIntentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a quote detailing the costs of upgrading to a new subscription.
     * Create Subscription Quote
     */
    async createSubscriptionQuoteRaw(requestParameters: CreateSubscriptionQuoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSubscriptionQuoteResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-quote.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/subscription/quote`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubscriptionQuoteDataToJSON(requestParameters['createSubscriptionQuoteData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSubscriptionQuoteResponseFromJSON(jsonValue));
    }

    /**
     * Create a quote detailing the costs of upgrading to a new subscription.
     * Create Subscription Quote
     */
    async createSubscriptionQuote(requestParameters: CreateSubscriptionQuoteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSubscriptionQuoteResponse> {
        const response = await this.createSubscriptionQuoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Payment Method
     */
    async deletePaymentMethodRaw(requestParameters: DeletePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-payment-method.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/payment-methods/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Payment Method
     */
    async deletePaymentMethod(requestParameters: DeletePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     * Display a list of available billing packages.
     * List Billing Packages
     */
    async listBillingPackagesRaw(requestParameters: ListBillingPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBillingPackagesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/packages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBillingPackagesResponseFromJSON(jsonValue));
    }

    /**
     * Display a list of available billing packages.
     * List Billing Packages
     */
    async listBillingPackages(requestParameters: ListBillingPackagesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBillingPackagesResponse> {
        const response = await this.listBillingPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * List Billing Product Prices
     */
    async listBillingProductPricesRaw(requestParameters: ListBillingProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBillingProductPricesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-product-price.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/product-prices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBillingProductPricesResponseFromJSON(jsonValue));
    }

    /**
     * 
     * List Billing Product Prices
     */
    async listBillingProductPrices(requestParameters: ListBillingProductPricesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBillingProductPricesResponse> {
        const response = await this.listBillingProductPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all billing quota definitions
     * List Billing Quota Definitions
     */
    async listBillingQuotaDefinitionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBillingQuotaDefinitionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-quota-definition.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/quota-definitions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBillingQuotaDefinitionsResponseFromJSON(jsonValue));
    }

    /**
     * List all billing quota definitions
     * List Billing Quota Definitions
     */
    async listBillingQuotaDefinitions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBillingQuotaDefinitionsResponse> {
        const response = await this.listBillingQuotaDefinitionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * List Billing Wallet Types
     */
    async listBillingWalletTypesRaw(requestParameters: ListBillingWalletTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBillingWalletTypesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-wallet-type.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/wallet-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBillingWalletTypesResponseFromJSON(jsonValue));
    }

    /**
     * List Billing Wallet Types
     */
    async listBillingWalletTypes(requestParameters: ListBillingWalletTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBillingWalletTypesResponse> {
        const response = await this.listBillingWalletTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * ListBillingWallets
     */
    async listBillingWalletsRaw(requestParameters: ListBillingWalletsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBillingWalletsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-wallet.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/wallets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBillingWalletsResponseFromJSON(jsonValue));
    }

    /**
     * 
     * ListBillingWallets
     */
    async listBillingWallets(requestParameters: ListBillingWalletsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBillingWalletsResponse> {
        const response = await this.listBillingWalletsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Coupon Redemptions
     */
    async listCouponRedemptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCouponRedemptionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-coupon-redemption.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/coupons/redemptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCouponRedemptionsResponseFromJSON(jsonValue));
    }

    /**
     * List Coupon Redemptions
     */
    async listCouponRedemptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCouponRedemptionsResponse> {
        const response = await this.listCouponRedemptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * List all invoices
     * List Invoices
     */
    async listInvoicesRaw(requestParameters: ListInvoicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInvoicesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-invoice.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInvoicesResponseFromJSON(jsonValue));
    }

    /**
     * List all invoices
     * List Invoices
     */
    async listInvoices(requestParameters: ListInvoicesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInvoicesResponse> {
        const response = await this.listInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the next billing events for your company
     * List Next Billing Events
     */
    async listNextBillingEventsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListNextBillingEventsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-event.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/next`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListNextBillingEventsResponseFromJSON(jsonValue));
    }

    /**
     * List the next billing events for your company
     * List Next Billing Events
     */
    async listNextBillingEvents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListNextBillingEventsResponse> {
        const response = await this.listNextBillingEventsRaw(initOverrides);
        return await response.value();
    }

    /**
     * List all payment methods on file for the company
     * List Payment Methods
     */
    async listPaymentMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPaymentMethodsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-payment-method.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/payment-methods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPaymentMethodsResponseFromJSON(jsonValue));
    }

    /**
     * List all payment methods on file for the company
     * List Payment Methods
     */
    async listPaymentMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPaymentMethodsResponse> {
        const response = await this.listPaymentMethodsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Show a list of your referrals
     * List Referrals
     */
    async listReferralsRaw(requestParameters: ListReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListReferralsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-referrals.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/referrals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListReferralsResponseFromJSON(jsonValue));
    }

    /**
     * Show a list of your referrals
     * List Referrals
     */
    async listReferrals(requestParameters: ListReferralsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListReferralsResponse> {
        const response = await this.listReferralsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refresh the url for an invoice
     */
    async refreshInvoiceUrlRaw(requestParameters: RefreshInvoiceUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefreshInvoiceUrlResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling refreshInvoiceUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-invoice.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/invoices/{id}/refresh-url`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefreshInvoiceUrlResponseFromJSON(jsonValue));
    }

    /**
     * Refresh the url for an invoice
     */
    async refreshInvoiceUrl(requestParameters: RefreshInvoiceUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefreshInvoiceUrlResponse> {
        const response = await this.refreshInvoiceUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Attempt to take payment on any outstanding invoices and restart any failed subscriptions.
     * Restore Account
     */
    async restoreAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-subscription.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/restore`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Attempt to take payment on any outstanding invoices and restart any failed subscriptions.
     * Restore Account
     */
    async restoreAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.restoreAccountRaw(initOverrides);
    }

    /**
     * Remove any pending downgrades / cancellations from a billing subscription.
     * Resume Billing Subscription
     */
    async resumeBillingSubscriptionRaw(requestParameters: ResumeBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResumeBillingSubscriptionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resumeBillingSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-subscription.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/subscriptions/{id}/resume`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResumeBillingSubscriptionResponseFromJSON(jsonValue));
    }

    /**
     * Remove any pending downgrades / cancellations from a billing subscription.
     * Resume Billing Subscription
     */
    async resumeBillingSubscription(requestParameters: ResumeBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResumeBillingSubscriptionResponse> {
        const response = await this.resumeBillingSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Show billing details for a company
     * Show Billing Details
     */
    async showBillingDetailsRaw(requestParameters: ShowBillingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowBillingDetailsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-details.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowBillingDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Show billing details for a company
     * Show Billing Details
     */
    async showBillingDetails(requestParameters: ShowBillingDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowBillingDetailsResponse> {
        const response = await this.showBillingDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Show a basic overview of a companies billing setup.
     * Show Billing Overview
     */
    async showBillingOverviewRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowBillingOverviewResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-overview.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/overview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowBillingOverviewResponseFromJSON(jsonValue));
    }

    /**
     * Show a basic overview of a companies billing setup.
     * Show Billing Overview
     */
    async showBillingOverview(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowBillingOverviewResponse> {
        const response = await this.showBillingOverviewRaw(initOverrides);
        return await response.value();
    }

    /**
     * Show Invoice
     */
    async showInvoiceRaw(requestParameters: ShowInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowInvoiceResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showInvoice().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-invoice.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/invoices/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowInvoiceResponseFromJSON(jsonValue));
    }

    /**
     * Show Invoice
     */
    async showInvoice(requestParameters: ShowInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowInvoiceResponse> {
        const response = await this.showInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Shows the currently subscribed billing plan for the company.
     * Show Current Subscription
     */
    async showLatestSubscriptionRaw(requestParameters: ShowLatestSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowLatestSubscriptionResponse>> {
        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-subscription.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowLatestSubscriptionResponseFromJSON(jsonValue));
    }

    /**
     * Shows the currently subscribed billing plan for the company.
     * Show Current Subscription
     */
    async showLatestSubscription(requestParameters: ShowLatestSubscriptionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowLatestSubscriptionResponse> {
        const response = await this.showLatestSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Show details about a referrer
     * Show Referrer Details
     */
    async showReferrerDetailsRaw(requestParameters: ShowReferrerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowReferrerDetailsResponse>> {
        if (requestParameters['companyRef'] == null) {
            throw new runtime.RequiredError(
                'companyRef',
                'Required parameter "companyRef" was null or undefined when calling showReferrerDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/billing/referrer/{companyRef}`.replace(`{${"companyRef"}}`, encodeURIComponent(String(requestParameters['companyRef']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowReferrerDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Show details about a referrer
     * Show Referrer Details
     */
    async showReferrerDetails(requestParameters: ShowReferrerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowReferrerDetailsResponse> {
        const response = await this.showReferrerDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * Top Up Billing Wallet
     */
    async topUpBillingWalletRaw(requestParameters: TopUpBillingWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopUpBillingWalletResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling topUpBillingWallet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-wallet.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/wallets/{id}/top-up`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TopUpBillingWalletDataToJSON(requestParameters['topUpBillingWalletData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopUpBillingWalletResponseFromJSON(jsonValue));
    }

    /**
     * 
     * Top Up Billing Wallet
     */
    async topUpBillingWallet(requestParameters: TopUpBillingWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopUpBillingWalletResponse> {
        const response = await this.topUpBillingWalletRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update billing details for a company
     * Update Billing Details
     */
    async updateBillingDetailsRaw(requestParameters: UpdateBillingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateBillingDetailsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-details.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/details`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingDetailsDataToJSON(requestParameters['updateBillingDetailsData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateBillingDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Update billing details for a company
     * Update Billing Details
     */
    async updateBillingDetails(requestParameters: UpdateBillingDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateBillingDetailsResponse> {
        const response = await this.updateBillingDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the current billing subscription
     * Update Billing Subscription
     */
    async updateBillingSubscriptionRaw(requestParameters: UpdateBillingSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateBillingSubscriptionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-subscription.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/subscription`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingSubscriptionDataToJSON(requestParameters['updateBillingSubscriptionData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateBillingSubscriptionResponseFromJSON(jsonValue));
    }

    /**
     * Update the current billing subscription
     * Update Billing Subscription
     */
    async updateBillingSubscription(requestParameters: UpdateBillingSubscriptionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateBillingSubscriptionResponse> {
        const response = await this.updateBillingSubscriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Billing Wallet
     */
    async updateBillingWalletRaw(requestParameters: UpdateBillingWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateBillingWalletResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBillingWallet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-wallet.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/wallets/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBillingWalletDataToJSON(requestParameters['updateBillingWalletData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateBillingWalletResponseFromJSON(jsonValue));
    }

    /**
     * Update Billing Wallet
     */
    async updateBillingWallet(requestParameters: UpdateBillingWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateBillingWalletResponse> {
        const response = await this.updateBillingWalletRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Payment Method
     */
    async updatePaymentMethodRaw(requestParameters: UpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdatePaymentMethodResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.billing-payment-method.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/billing/payment-methods/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePaymentMethodDataToJSON(requestParameters['updatePaymentMethodData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdatePaymentMethodResponseFromJSON(jsonValue));
    }

    /**
     * Update Payment Method
     */
    async updatePaymentMethod(requestParameters: UpdatePaymentMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdatePaymentMethodResponse> {
        const response = await this.updatePaymentMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
